import React from "react";
import PropTypes from "prop-types";

function TextInput({ label, onInputChange }) {
  const handleChange = (event) => {
    event.preventDefault();
    onInputChange({ [label]: event.target.value });
  };

  return (
    <div>
      <label htmlFor={label} className="sr-only">
        {label}
      </label>

      <input
        type="text"
        name={label}
        id={label}
        className=" shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full border-opacity-40 border-b border-white h-12 bg-highlight placeholder-white text-white"
        placeholder={label}
        onChange={handleChange}
      />
    </div>
  );
}

export default TextInput;

TextInput.propTypes = {
  label: PropTypes.string,
  onInputChange: PropTypes.func,
};
